import { render } from "./App.vue?vue&type=template&id=0d938c34"
import script from "@/assets/js/appmain.js?vue&type=script&lang=js&external"
export * from "@/assets/js/appmain.js?vue&type=script&lang=js&external"

import "./App.vue?vue&type=style&index=0&id=0d938c34&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__